// Anime Interactive Effects - Pro TCG Store
document.addEventListener('DOMContentLoaded', () => {
  // Scroll Animations (Fade-in-up)
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate');
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.product-card, .section').forEach(el => observer.observe(el));

  // Particle Effects on Card Hover (Shonen Explosion)
  const cards = document.querySelectorAll('.product-card');
  cards.forEach(card => {
    card.addEventListener('mouseenter', createParticles);
  });

  function createParticles(e) {
    for (let i = 0; i < 12; i++) {
      const particle = document.createElement('div');
      particle.style.cssText = `
        position: fixed; top: ${e.clientY}px; left: ${e.clientX}px;
        width: 8px; height: 8px; background: var(--neon-pink);
        border-radius: 50%; pointer-events: none;
        animation: explode 0.6s ease-out forwards;
      `;
      document.body.appendChild(particle);
      setTimeout(() => particle.remove(), 600);
    }
  }

  // Keyframes injected via CSS-in-JS for particles
  const style = document.createElement('style');
  style.textContent = `
    @keyframes explode {
      0% { transform: scale(1) translate(0); opacity: 1; }
      100% { transform: scale(0) translate(var(--dx), var(--dy)); opacity: 0; }
    }
  `;
  document.head.appendChild(style);

  // Scroll Progress Bar
  window.addEventListener('scroll', () => {
    const scrolled = (window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100;
    document.documentElement.style.setProperty('--scroll-progress', `${scrolled}%`);
  });

  // Auto-start Background Music (muted first, user gesture)
  const bgMusic = new Audio('https://www.chosic.com/wp-content/uploads/2023/01/Japanese-Background-Music-01.mp3'); // Royalty-free Japanese relaxing [web:17]
  bgMusic.loop = true;
  bgMusic.volume = 0.3;
  document.addEventListener('click', () => bgMusic.play().catch(() => {}), { once: true });
});
